import $ from 'jquery';
import InfiniteScroll from 'infinite-scroll';

// import 'slick';
import ScrollReveal from 'scrollreveal';



$(document).ready(function () {
  // ページが読み込まれた後に実行されるコード

  // ul要素内のli要素を取得
  const $liElements = $(".sections ul li");

  // li要素に対してループを行う
  $liElements.each(function (index) {
    if (index % 7 === 0) {
      // 7の倍数の場合にtwoColクラスを付与
      $(this).addClass("twoCol");
    }
  });
});


function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('/img/', true, /\.(png|jpe?g|gif|svg)$/));


/*====================================================================
  アコーディオン
====================================================================*/
// .s_01.accordion_one
$(function () {
  //.accordion_oneの中の.accordion_headerがクリックされたら
  $('.s_01 .accordion_one .accordion_header').click(function () {
    //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
    $(this).next('.accordion_inner').slideToggle();
    $(this).toggleClass("open");
  });
});

// .s_02 .accordion_one
$(function () {
  //.accordion_oneの中の.accordion_headerがクリックされたら
  $('.s_02 .accordion_one .accordion_header').click(function () {
    //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
    $(this).next('.accordion_inner').slideToggle();
    $(this).toggleClass("open");
  });
});


// $(function () {
//   $('.ac-parent').on('click', function () {
//     $(this).next().slideToggle();
//     //openクラスをつける
//     $(this).toggleClass("open");


//   });
// });


/*====================================================================
  高さ揃えるjs
====================================================================*/
function equalizeItemHeights() {
  const items = document.querySelectorAll('.matchHeight');
  let maxHeight = 0;

  // まず、すべてのアイテムの高さをリセットします。
  items.forEach(item => {
    item.style.height = 'auto';
  });

  // 次に、最も高いアイテムの高さを見つけます。
  items.forEach(item => {
    if (item.offsetHeight > maxHeight) {
      maxHeight = item.offsetHeight;
    }
  });

  // 最後に、すべてのアイテムの高さを最も高いアイテムの高さに設定します。
  items.forEach(item => {
    item.style.height = `${maxHeight}px`;
  });
}

// ページ読み込み時とウィンドウサイズが変更された時に高さを揃える
window.addEventListener('load', equalizeItemHeights);
window.addEventListener('resize', equalizeItemHeights);


jQuery(document).ready(function ($) {
  $(document).on('click', '#js-zip', function () {
    console.log("住所検索クリック");

    AjaxZip3.zip2addr('your-postcode', '', 'your-address', 'your-address');
  });
});

jQuery(document).ready(function ($) {
  $(document).on('click', '#js-zip2', function () {
    console.log("住所検索クリック");

    AjaxZip3.zip2addr('your-postcode2', '', 'your-address2', 'your-address2');
  });
});



/*====================================================================
  フォームの変更js
====================================================================*/
$(document).ready(function () {
  // ドキュメントが読み込まれた後に実行
  $('select').each(function () { // ページ内の全てのselect要素に対して処理を行う
    if ($(this).val() == "お問い合わせ種別を選択してください") {
      $(this).css('color', '#ddd'); // 初期状態のテキスト色を設定
    } else {
      $(this).css('color', '#333'); // 選択済みの場合のテキスト色を設定
    }
  });

  // select要素の値が変更されたときのイベントハンドラを設定
  $('select').change(function () {
    if ($(this).val() == "お問い合わせ種別を選択してください") {
      $(this).css('color', '#B4B4B4');
    } else {
      $(this).css('color', '#000');
    }
  });
});


/*====================================================================
  スクロール系js
====================================================================*/
$(document).ready(function () {
  var pagetop = $('.pagetop');
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
  pagetop.click(function () {
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });
});


$(function () {
  const hash = location.hash;
  if (hash) {
    $("html, body").stop().scrollTop(0);
    setTimeout(function () {
      const target = $(hash),
        position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, 500, "swing");
    });
  }
});


/*====================================================================
  グロナビ
====================================================================*/
$(function () {
  $("nav a").each(function () {
    var navHref = new URL(this.href).pathname;
    var locationHref = new URL(location.href).pathname;

    // 現在のURLがナビゲーションリンクのURLを含むかどうかをチェック
    if (locationHref.startsWith(navHref) && navHref !== '/') {
      $(this).parents("li").addClass("current");
    }
  });
});


/*====================================================================
  右クリック禁止
====================================================================*/
document.addEventListener('contextmenu', function (e) {
  if (e.target.nodeName === 'IMG') {
    e.preventDefault();
  }
}, false);

document.addEventListener('dragstart', function (e) {
  if (e.target.nodeName === 'IMG') {
    e.preventDefault();
  }
}, false);


document.addEventListener('contextmenu', function (e) {
  e.preventDefault(); // 右クリック禁止
}, false);

document.addEventListener('selectstart', function (e) {
  e.preventDefault(); // テキスト選択禁止
}, false);

document.addEventListener('copy', function (e) {
  e.preventDefault(); // コピー禁止
}, false);


/*====================================================================
  スパム対策と無限スクロール
====================================================================*/
document.addEventListener('DOMContentLoaded', function () {
  var emailLink = document.getElementById('emailLink');
  if (emailLink !== null) { // 要素が存在するかをチェック
    var email = 'bunka' + '@' + 'tanko.co.jp'; // スパム対策で分割して記述
    emailLink.href = 'mailto:' + email;
  }

  // var infScroll = new InfiniteScroll('.news__cont.__type2 ul', { // 記事を挿入していく要素を指定
  //   append: '.koko',             // 各記事の要素
  //   path: '.next_posts_link a',  // 次のページへのリンク要素を指定
  //   hideNav: '.next_posts_link', // 指定要素を非表示にする（ここは無くてもOK）
  //   button: '.view-more-button', // 記事を読み込むトリガーとなる要素を指定
  //   scrollThreshold: true,      // スクロールで読み込む：falseで機能停止（デフォルトはtrue）
  //   status: '.page-load-status', // ステータス部分の要素を指定
  //   history: false             // falseで履歴に残さない
  // });

  // // 新しいページが読み込まれた後に実行されるイベントリスナー
  // infScroll.on('append', function (response, path, items) {
  //   // 新しく追加された要素に対して処理を行う
  //   $(items).each(function (index, item) {
  //     // 全体のインデックスを計算
  //     let globalIndex = $('.news__cont.__type2 ul .koko').index(item);
  //     if ((globalIndex) % 7 === 0) {
  //       $(item).addClass("twoCol");
  //     }
  //   });
  // });



  if (document.body.classList.contains('home') || document.body.classList.contains('post-type-archive-science') || document.body.classList.contains('search')) {
    // 無限スクロールの初期化と設定
    var infScroll = new InfiniteScroll('.news__cont.__type2 ul', {
      append: '.koko',
      path: '.next_posts_link a',
      hideNav: '.next_posts_link',
      button: '.view-more-button',
      scrollThreshold: .1,
      status: '.page-load-status',
      history: false
    });

    // 無限スクロールのイベントリスナー設定
    infScroll.on('append', function (response, path, items) {
      $(items).each(function (index, item) {
        // search ページでは twoCol クラスの付与をスキップ
        if (!document.body.classList.contains('search')) {
          let globalIndex = $('.news__cont.__type2 ul .koko').index(item);
          if (globalIndex % 7 === 0) {
            $(item).addClass("twoCol");
          }
        }
        $(item).addClass('fadeIn');
      });
    });
  }



});




/*====================================================================
  ハンバーガーメニュー
====================================================================*/
function disableScroll() {
  // スクロール禁止
  document.body.style.overflow = 'hidden';
}

function enableScroll() {
  // スクロール許可
  document.body.style.overflow = '';
}

function test() {
  let clicked = document.getElementsByClassName('logo-images');
  for (let i = 0; i < clicked.length; i++) {
    clicked[i].classList.toggle('ttt');
  }
}

function test2() {
  let clicked = document.getElementsByClassName('logo-images2');
  for (let i = 0; i < clicked.length; i++) {
    clicked[i].classList.toggle('sss');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  let overlayInput = document.getElementById('overlay-input');

  overlayInput.addEventListener('change', function () {
    if (this.checked) {
      disableScroll();
      test();
      test2();
    } else {
      enableScroll();
      test();
      test2();
    }
  });
});


/*====================================================================
   フォームのセレクトタグの文字色変更
====================================================================*/
$(document).ready(function () {
  // 引数としてselect要素のIDを受け取るように関数を一般化
  function updateSelectColor(selectId) {
    if ($(selectId).val() == "お問い合わせ種別を選択してください") {
      $(selectId).css('color', '#B4B4B4');
    } else {
      $(selectId).css('color', '#222');
    }
  }

  // 各select要素に対してイベントリスナーと初期色設定を適用
  ['#selected', '#selected2'].forEach(function (selectId) {
    $(selectId).on('change', function () { updateSelectColor(selectId); });
    updateSelectColor(selectId); // ページ読み込み時にも色を更新
  });
});


$(document).ready(function () {
  $('#file_attachment').on('change', function () {
    if ($(this).val() !== '') {
      $('.tempu1 input[type=file]').css('color', '#222');
    } else {
      $('.tempu1 input[type=file]').css('color', '#B4B4B4');
    }
  });
});

$(document).ready(function () {
  $('#file_attachment2').on('change', function () {
    if ($(this).val() !== '') {
      $('.tempu2 input[type=file]').css('color', '#222');
    } else {
      $('.tempu2 input[type=file]').css('color', '#B4B4B4');
    }
  });
});



/*====================================================================
   modalナビ
====================================================================*/
$(function () {
  const modal = $(".modal_content");
  const overlay = $(".modal_overlay");
  const topmodal = $(".top-modal");

  // モーダルを開く
  $(".modal_open").on("click", function () {
    modal.addClass("open");
    overlay.addClass("open");
    topmodal.addClass("none");
    $('body').addClass('no-scroll');
    modal.scrollTop(0); // モーダルのスクロール位置をリセット
  });

  // モーダルを閉じる
  $(".modal_close").on("click", function () {
    modal.removeClass("open");
    overlay.removeClass("open");
    topmodal.removeClass("none");
    $('body').removeClass('no-scroll');

  });

  // オーバーレイをクリックしてモーダルを閉じる
  overlay.on("click", function () {
    modal.removeClass("open");
    overlay.removeClass("open");
    topmodal.removeClass("none");
    $('body').removeClass('no-scroll');

  });

});


/*====================================================================
  ハンバーガーメニューの高さ調整
====================================================================*/
$(document).ready(function () {
  $('#overlay-input').change(function () {
    if ($(this).is(':checked')) {
      // メニューが開いている間は背景のスクロールを禁止
      $('html, body').addClass('no-scroll'); // CSSクラスでスクロール禁止を制御
    } else {
      // メニューが閉じたら背景のスクロールを許可
      $('html, body').removeClass('no-scroll'); // CSSクラスを削除してスクロール許可
    }
  });
});


// let element = document.getElementById('search');
// if (element) {
//   // elementが存在する場合にのみ実行


// }

/*====================================================================
  スマホメニューのお問い合わせボタン
====================================================================*/

$(document).ready(function ($) {
  $(".sp-info-wrapper").on("click", function () {
    $(".toggle-menu").slideToggle(); // クリックで表示/非表示を切り替え
  });
});







